import { httpGetObservable } from './utils';


const api = {
  fetchList: (url) => httpGetObservable(url),
  chatRoomById: (url) => httpGetObservable(url),
};

export default api;
